export default function Pill({ children, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "6px 16px",
        borderRadius: "20px",
        border: active ? "none" : "1px solid var(--border-strong)",
        background: active ? "#D4AF37" : "transparent",
        color: active ? "#0F1A10" : "var(--text-muted)",
        fontSize: "12px",
        fontFamily: "'JetBrains Mono', monospace",
        cursor: "pointer",
        letterSpacing: "0.05em",
        transition: "all 0.2s",
        fontWeight: active ? "600" : "400",
      }}
    >
      {children}
    </button>
  );
}
